module.exports = __webpack_public_path__ + "static/img/no-img-2.b62a685.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/no-img-2.jpg
// module id = igSG
// module chunks = 2